import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ItemHelper from '@wix/wixrest-utils/dist/openrest-helpers/Item';
import { getIcon } from '@wix/restaurants-menus-icons';
import StarFilled from 'wix-ui-icons-common/StarFilled';
import styles from './MenuItem.scss';
import { getItemErrors } from '../../utils/DishUtils';

import moment from 'moment';
import { DeliveryTypes } from '../../utils/constants';

import { Card, Text } from 'wix-style-react';

export const tmpLabels = {
  hot: 'Hot',
  spicy2: 'Hot',
  extrahot: 'Extra Hot',
  spicy3: 'Extra Hot',
  glutenfree: 'Gluten Free',
  organic: 'Organic',
  spicy: 'Spicy',
  spicy1: 'Spicy',
  vegan: 'Vegan',
  vegetarian: 'Vegetarian',
};

class MenuItem extends React.PureComponent {
  static propTypes = {
    item: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired,
    simplifiedMenu: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    deliveryType: PropTypes.oneOf([DeliveryTypes.DELIVERY, DeliveryTypes.TAKEOUT]),
  };

  constructor() {
    super();

    this._getLabel = this._getLabel.bind(this);
    this._onClick = this._onClick.bind(this);
  }

  render() {
    const { item } = this.props;

    const description = this._getDescription();
    const labels = this._getLabels();

    return (
      <button onClick={this._onClick} data-hook={`menu-item-id-${item.id}`} className={styles.button}>
        <Card className={styles.wrapper}>
          {description}
          {labels}
        </Card>
      </button>
    );
  }

  resolvePriceLabel = () => {
    const { item, locale, simplifiedMenu, currency, deliveryType } = this.props;
    const errors = getItemErrors(item, moment(), deliveryType, simplifiedMenu);
    const isSoldOut = errors.find(error => error.type === 'error.soldout');
    const isUnavailable = errors.find(error => error.type === 'error.unavailable');
    const isUnsupportedDeliveryType = errors.find(error => error.type === 'error.deliveryType');
    const soldOutLabel = () => <div className={styles.soldout}>Sold Out</div>;
    const unavailableLabel = () => <div className={styles.soldout}>Unavailable</div>;

    if (isSoldOut) {
      return soldOutLabel();
    }
    if (isUnavailable || isUnsupportedDeliveryType) {
      return unavailableLabel();
    }

    const price = errors.find(error => error.type === 'error.soldout')
      ? soldOutLabel()
      : ItemHelper.getPriceStr({
          item,
          currency,
          menu: simplifiedMenu,
          useSimplifiedItems: true,
          locale,
        });
    return price;
  };

  _getDescription() {
    const { item, locale } = this.props;
    const isFeatured = get(item, 'labels', []).indexOf('featured') > -1;
    const priceLabel = this.resolvePriceLabel();

    return (
      <div className={styles.description} data-hook="menu-item-wrapper">
        <div className={styles.title} data-hook="menu-item-title">
          <Text size="medium" weight="normal" className={styles.title}>
            {item.title[locale]}
            {isFeatured ? (
              <span className={styles.star} data-hook="star">
                <StarFilled size={20} />
              </span>
            ) : null}
          </Text>
        </div>
        <div className={styles.price} data-hook="menu-item-price">
          <Text size="medium" weight="normal" secondary>
            {priceLabel}
          </Text>
        </div>
      </div>
    );
  }

  _getLabels() {
    const { item } = this.props;
    const labels = (item.labels || []).filter(label => label !== 'featured');

    return labels.length ? (
      <div className={styles.labels} data-hook="menu-item-labels">
        {labels.map(this._getLabel)}
      </div>
    ) : null;
  }

  _getLabel(label) {
    const Icon = getIcon('full-bg', label);

    return Icon ? (
      <div className={styles.label} key={label} title={tmpLabels[label]}>
        <Icon size={24} />
      </div>
    ) : null;
  }

  _onClick() {
    const { onClick, item } = this.props;
    onClick(item);
  }
}

export default MenuItem;
